import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card__case" }
const _hoisted_3 = {
  class: "card__slider",
  style: {"position":"relative"}
}
const _hoisted_4 = {
  key: 0,
  class: "card__sale-case",
  style: {"z-index":"2"}
}
const _hoisted_5 = { class: "card__swiper" }
const _hoisted_6 = ["alt"]
const _hoisted_7 = { class: "card__info" }
const _hoisted_8 = { class: "card__info-up" }
const _hoisted_9 = { class: "card__info-container" }
const _hoisted_10 = { class: "card__info-container-gramm" }
const _hoisted_11 = { class: "card__info-container-price" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "card__info-down" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "card__title-category" }
const _hoisted_17 = { class: "card__price-category" }
const _hoisted_18 = { style: {"margin-top":"12px","display":"flex","justify-content":"space-between","flex-direction":"row-reverse"} }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 0,
  class: "loader"
}
const _hoisted_21 = {
  key: 1,
  width: "16",
  height: "19",
  viewBox: "0 0 16 19",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.926456 0.5C0.870786 0.5 0.816181 0.505305 0.761409 0.515381C0.266895 0.606352 -0.0755563 1.10708 0.0143553 1.60742L1.8733 11.9521C1.96846 12.4817 2.43372 12.875 2.96565 12.875H12.3863C12.8471 12.875 13.267 12.582 13.4287 12.1455L15.9305 5.39551C15.9773 5.2692 16 5.13489 16 5C16 4.38867 15.4923 3.875 14.8881 3.875H2.5943L2.22077 1.60962C2.11623 0.974977 1.56236 0.5 0.926456 0.5ZM2.41839 5.5625H14.0846L11.9998 11.1875H3.43039L2.41839 5.5625ZM3.70619 15.125C2.78507 15.125 2.03835 15.8805 2.03835 16.8125C2.03835 17.7445 2.78507 18.5 3.70619 18.5C4.62731 18.5 5.37403 17.7445 5.37403 16.8125C5.37403 15.8805 4.62731 15.125 3.70619 15.125ZM11.4894 15.125C10.5683 15.125 9.82161 15.8805 9.82161 16.8125C9.82161 17.7445 10.5683 18.5 11.4894 18.5C12.4106 18.5 13.1573 17.7445 13.1573 16.8125C13.1573 15.8805 12.4106 15.125 11.4894 15.125Z",
  fill: "white"
}, null, -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  width: "18",
  height: "14",
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M18 2L6 14L0.5 8.5L1.91 7.09L6 11.17L16.59 0.59L18 2Z",
    fill: "white"
  })
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "13",
  viewBox: "0 0 20 13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M4.96064 2.89996L3.07143 11.54H16.2959L18.1851 2.89996M4.96064 2.89996L5.27551 1.45996H18.5L18.1851 2.89996M4.96064 2.89996L10.7857 6.49996L18.1851 2.89996M0.5 2.17996H4.17347M1.28717 5.29996H3.49125M2.09184 8.33996H2.82653",
    stroke: "white"
  })
], -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 2,
  class: "card__price"
}
const _hoisted_29 = {
  key: 2,
  class: "card__sale-price"
}
const _hoisted_30 = {
  key: 3,
  class: "card__notification"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "card__notification-title" }, "Нет в наличии", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "card__notification-text" }, "Уведомить о поступлении", -1)
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ACounter = _resolveComponent("ACounter")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.displayDiscountPercent)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " - " + _toDisplayString(_ctx.displayDiscountPercent) + " % ", 1))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_swiper, {
            pagination: {
              clickable: true,
            },
            modules: _ctx.modules,
            class: "cardMySwiper"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayImages, (image, idx) => {
                return (_openBlock(), _createBlock(_component_swiper_slide, {
                  class: "card__image",
                  key: idx
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("img", {
                      alt: _ctx.item.name,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetail(_ctx.item)))
                    }, null, 8, _hoisted_6), [
                      [_directive_lazy, { src: image }]
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }, 8, ["modules"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.displayInfoRatio), 1),
            _createElementVNode("p", _hoisted_11, [
              (!_ctx.selectedOffer && _ctx.item.type === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12, "от "))
                : _createCommentVNode("", true),
              _createTextVNode(" " + _toDisplayString(_ctx.displayInfoPrice) + " ", 1),
              (_ctx.item.type === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_13, " "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("p", {
            class: "card__title",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openDetail(_ctx.item)))
          }, _toDisplayString(_ctx.item.name), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          (_ctx.item.type === 3)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{ invalid: _ctx.invalid }, "card__category"])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.offers, (offer, idx) => {
                  return (_openBlock(), _createElementBlock("button", {
                    onClick: ($event: any) => (_ctx.changeSelectedOffer(offer)),
                    class: _normalizeClass(["card__item", [
                {
                  'card__item--active-select':
                    offer.id == _ctx.selectedOffer?.id && idx == 2,
                },
                {
                  'card__item--active-choise':
                    offer.id == _ctx.selectedOffer?.id && idx == 1,
                },
                {
                  'card__item--active-prime':
                    offer.id == _ctx.selectedOffer?.id && idx == 0,
                },
                { 'card__item--error': false },
              ]]),
                    key: idx
                  }, [
                    _createElementVNode("p", _hoisted_16, _toDisplayString(offer.name), 1),
                    _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.priceFormat(offer.ratioPrice)), 1)
                  ], 10, _hoisted_15))
                }), 128))
              ], 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_18, [
            (
                (_ctx.item.type === 1 || (_ctx.item.type === 3 && _ctx.selectedOffer)) &&
                _ctx.quantity > 0
              )
              ? (_openBlock(), _createBlock(_component_ACounter, {
                  key: 0,
                  modelValue: _ctx.quantity,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.quantity) = $event)),
                  price: _ctx.price,
                  ratio: _ctx.ratio,
                  measure: _ctx.measure,
                  onChange: _ctx.changeBasket,
                  onDeleteItem: _ctx.deleteItem,
                  loading: _ctx.loading
                }, null, 8, ["modelValue", "price", "ratio", "measure", "onChange", "onDeleteItem", "loading"]))
              : _createCommentVNode("", true),
            (_ctx.quantity == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  (_ctx.quantity == 0 && _ctx.available)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addInvalid())),
                        style: {"width":"44px","height":"44px","background":"#0f4735","border-radius":"4px","display":"flex","flex-direction":"row","justify-content":"center","align-items":"center","padding":"12px 16px","gap":"12px"}
                      }, [
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                          : _createCommentVNode("", true),
                        (!_ctx.loading)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_21, _hoisted_23))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.quantity != 0 && _ctx.available)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showBasket())),
                        style: {"width":"44px","height":"44px","background":"#393939","border-radius":"4px","display":"flex","flex-direction":"row","justify-content":"center","align-items":"center","padding":"12px 16px","gap":"12px"}
                      }, _hoisted_25))
                    : _createCommentVNode("", true),
                  (!_ctx.available)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 2,
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showNotification(_ctx.item.id))),
                        style: {"width":"44px","height":"44px","background":"#0f4735","border-radius":"4px","display":"flex","flex-direction":"row","justify-content":"center","align-items":"center","padding":"12px 8px","gap":"12px"}
                      }, _hoisted_27))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (
                (_ctx.item.available || _ctx.selectedOffer?.available) && _ctx.quantity == 0
              )
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  (!_ctx.selectedOffer)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: _normalizeClass(["card__current-price", {
                  'card__current-price--black': _ctx.displayDiscountPercent == 0,
                }])
                      }, _toDisplayString(_ctx.displayPrice), 3))
                    : _createCommentVNode("", true),
                  (_ctx.selectedOffer)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 1,
                        class: _normalizeClass(["card__current-price", {
                  'card__current-price--black': _ctx.displayDiscountPercent == 0,
                }])
                      }, _toDisplayString(this.priceFormat(_ctx.selectedOffer.ratioPrice)), 3))
                    : _createCommentVNode("", true),
                  (_ctx.displayDiscountPrice)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.displayDiscountPrice), 1))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.available)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_33))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}